import {CustomEditor} from 'ckeditor5-extra-build'
import {Lang} from 'yougile-lang'
import {
  showConfirm,
  showDeleteConfirm
} from '@components/common/base/notifications/show-confirm'
import {MessageUtils} from '@extensions/message-utils'
import {ChatInputStore} from './chat-input'
import {ChatStore} from './chat-store'

export const handleEditCanceling = async (props: {
  editor: CustomEditor
  chatStore: ChatStore
  chatInputStore: ChatInputStore
  onConfirmed?: () => void
  onCancel?: () => void
}): Promise<void> => {
  const {editor, chatStore, chatInputStore, onConfirmed, onCancel} = props

  const prevHtmlText = MessageUtils.renderHtmlForEdit(
    chatStore.state.messageToEdit
  )

  if (
    (editor.getData() !== prevHtmlText ||
      chatInputStore.state.chosenFiles.length) &&
    !(await showDeleteConfirm(Lang.msg.chat.editCancelHint, false, {
      primaryBtnText: Lang.msg.chat.editCancelButton
    }))
  ) {
    editor.focus()
    onCancel?.()
    return
  }
  onConfirmed?.()
  chatStore.stopEdit()
  chatInputStore.clearTyped(true)
  editor.setData('')
  editor.focus()
}

export const handleReplyCanceling = async (props: {
  editor: CustomEditor
  chatStore: ChatStore
  chatInputStore: ChatInputStore
  onConfirmed?: () => void
  onCancel?: () => void
}): Promise<void> => {
  const {editor, chatStore, chatInputStore, onConfirmed, onCancel} = props

  if (
    (editor.getData() || chatInputStore.state.chosenFiles.length) &&
    !(await showConfirm(Lang.msg.chat.replyCancelHint))
  ) {
    editor.focus()
    onCancel?.()
    return
  }
  onConfirmed?.()
  chatStore.cancelReply()
  editor.focus()
}
